import { render, staticRenderFns } from "./PageWrapDefault.vue?vue&type=template&id=671eaa4c&scoped=true"
import script from "./PageWrapDefault.vue?vue&type=script&lang=ts"
export * from "./PageWrapDefault.vue?vue&type=script&lang=ts"
import style0 from "./PageWrapDefault.vue?vue&type=style&index=0&id=671eaa4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671eaa4c",
  null
  
)

export default component.exports